var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvLayoutTopLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 118,
    viewBox: "0 0 123 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2118_112246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 123,
    height: 118
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.310547 0H122.146V117.954H0.310547V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2118_112246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2118_112246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -66,
    width: 190,
    height: 183
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9577 -65.9316L190.14 0.775261L121.376 116.898L1.19336 50.1916L69.9577 -65.9316Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2118_112246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2118_112246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -66,
    width: 121,
    height: 183
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.326 116.868L1.19336 50.1916L69.9577 -65.9316L121.326 116.868Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2118_112246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9577 -65.9316L190.14 0.775261L121.376 116.898L1.19336 50.1916L69.9577 -65.9316Z",
    fill: "#009CDF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvLayoutTopLight);
export default __webpack_public_path__ + "static/media/adv-layout-top-light.985ae2dba35d37f70ecbf037e9747c54.svg";
export { ForwardRef as ReactComponent };